import React, { useEffect, useState } from "react";
import { Col, Drawer, Spin } from "antd";
import CustomList from "../../components/List";
import ListItem from "../../components/ListItem";
import CustomPagination from "../../components/CustomPagination";
import { useProcuringEntity } from "../../../hooks/useProcuringEntity";
import { useCscStaffs } from "../../../hooks/useDataHooks";


const Position = { xxl: 5, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 };
const Proposed_name = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 };
const replacement = { xxl: 4, xl: 4, lg: 4, md: 0, sm: 0, xs: 0 }; 
const status = { xxl: 5, xl: 5, lg: 5, md: 5, sm: 5, xs: 5 };
const remarks = { xxl: 5, xl: 5, lg: 5, md: 0, sm: 0, xs: 0 };

const headerLayout = [
  { ...Position, header: "Position" },
  { ...Proposed_name, header: "Proposed Name" },
  { ...replacement, header: "Replacement" },
  { ...status, header: "Mobilization (%)" },
  { ...remarks, header: "Remarks" },
];

const HumanResources = ({procuringEntityId}) => {
  const [activeItem, setActiveItem] = useState(null);
  const [visible, setVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
 
  const { contract } = useProcuringEntity(procuringEntityId);
  const contractId = contract?.id;

  const { cscStaffs, pagination, loading, error } = useCscStaffs(contractId, currentPage, pageSize);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleRowClick = (item) => {
    setActiveItem(item);
    setVisible(true);
  };

  const handleCloseDrawer = () => {
    setVisible(false);
    setActiveItem(null);
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    setActiveItem(null);
  };

  if (loading) {
    return (
      <div className="prst-table">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
            width: "100%",
            padding: "20px"
          }}
        >
          <Spin tip="Loading staff details..." />
        </div>
      </div>
    );
  }

  return (
    <>
        <div className="prst-table">
          {error && (
            <div style={{ 
              margin: "16px 0", 
              padding: "16px", 
              backgroundColor: "#fff2f0", 
              border: "1px solid #ffccc7", 
              borderRadius: "6px",
              color: "#cf1322"
            }}>
              <strong>Error:</strong> Failed to load CSC staff data. Please try again later.
            </div>
          )}
                
          {!loading && !error && cscStaffs.length === 0 && (
            <div style={{ 
              margin: "16px 0", 
              padding: "16px", 
              backgroundColor: "#f6ffed", 
              border: "1px solid #b7eb8f", 
              borderRadius: "6px",
              color: "#389e0d",
              textAlign: "center"
            }}>
              <strong>No Data Available:</strong> No CSC staff data found for the selected contract.
            </div>
          )}

          <CustomList
            itemName={`Mobilized Staffs`}
            title={`Mobilized Staffs`}
            items={cscStaffs}
            page={currentPage}
            itemCount={pagination?.total || 0}
            loading={loading}
            headerLayout={headerLayout}
            renderListItem={({ item }) => (
                <ListItem
                  key={item.id}
                  name={item?.sub_project?.name || "no name"}
                  item={item}
                  isPackage={false}
                  renderActions={() => {}}
                  onClick={() => handleRowClick(item)}
                  style={{
                    backgroundColor:
                      activeItem?.id === item.id
                        ? "#f0f0f0"
                        : "transparent",
                  }}
                >
                  <Col
                    {...Position}
                    className="contentEllipse"
                    data-label="Position"
                    title={item?.position?.length > 20 ? item?.position.slice(0, 20) + "..." : item?.position || "-"}
                  >
                    {item?.position?.length > 20 ? item?.position.slice(0, 20) + "..." : item?.position || "-"}
                  </Col>
                  <Col 
                    {...Proposed_name} 
                    style={{ justifyContent: "center" }} 
                    className="contentEllipse"
                    data-label="Proposed Name"
                  >
                    {item?.proposed_name?.length > 25 ? item?.proposed_name.slice(0, 25) + "..." : item?.proposed_name || "-"}
                  </Col>
                  <Col 
                    {...replacement} 
                    style={{ justifyContent: "center" }} 
                    className="contentEllipse"
                    data-label="Replacement"
                  >
                    {item?.replacement || "-"}
                  </Col>
                  <Col 
                    {...status} 
                    style={{ justifyContent: "center" }} 
                    className="contentEllipse"
                    data-label="Mobilization Status"
                  >
                    {item?.status}
                  </Col>
                  <Col 
                    {...remarks} 
                    className="contentEllipse"
                    data-label="Remarks"
                  >
                    {item?.remarks?.length > 30 ? item?.remarks.slice(0, 30) + "..." : item?.remarks || "-"}
                  </Col>
                  <button className="view-card-details">View Details</button>
                </ListItem>
            )}
          />

          <CustomPagination 
            pagination={pagination}
            onPageChange={handlePageChange}
            loading={loading}
          />
        </div>

      <Drawer
        title="Staff Details"
        placement="right"
        closable={true}
        onClose={handleCloseDrawer}
        visible={visible}
        width={720}
      >
        <p>
          <strong>Position:</strong> {activeItem?.position || "-"}
        </p>
        <p>
          <strong>Replacement:</strong> {activeItem?.replacement || "-"}
        </p>
        <p>
          <strong>Proposed Name:</strong> {activeItem?.proposed_name || "-"}
        </p>
        <p>
          <strong>Status:</strong> {activeItem?.status || "-"}
        </p>
        <p>
          <strong>Remarks:</strong> {activeItem?.remarks || "-"}
        </p>
      </Drawer>
    </>
  );
};

export default HumanResources;
